import { useEffect, useState } from "react";

import { useAppSelector } from "./use-redux";

export /**
 *This hool is used to fetch browser fingerprint
 *
 * @param {*} data
 * @return {*}
 */
const usefetchBrowserInfo = () => {
  const [userAgent, setUserAgent] = useState<string>("");
  const [geoLocation, setGeoLocation] = useState<string>("");
  const deviceFingerPrint = useAppSelector((state) => state?.global?.deviceFingerPrint);

  useEffect(() => {
    let mount = true;
    // geolocation
    // if ('geolocation' in navigator) {
    //     navigator.geolocation.getCurrentPosition(position => {
    //         const { latitude, longitude } = position.coords;
    //         console.log({ latitude, longitude })
    //     }, error => {
    //         console.error('Error fetching geolocation:', error);
    //     });
    // } else {
    //     console.error('Geolocation is not supported');
    // }

    // userAgent
    const userAgent = navigator.userAgent;
    if (userAgent) {
      setUserAgent(userAgent);
    }

    return () => {
      mount = false;
    };
  }, []);

  return { deviceFingerPrint, userAgent, geoLocation };
};
